import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
    selector: 'app-busy-indicator',
    templateUrl: './busy-indicator.component.html',
    styleUrls: ['./busy-indicator.component.css'],
    standalone: false
})
export class BusyIndicatorComponent implements OnInit {
  message = 'Please wait...';

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private dialogRef: MatDialogRef<BusyIndicatorComponent>) {
      this.message = data.message;
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }
}
